import React, { useState, useEffect } from "react";
import { useParams, useNavigate, Link } from "react-router-dom";
import { Form, Modal } from "antd";
import {
	InnerForm,
	OrderData,
	ButtonContainer,
	Inner,
	PageWrapper,
	TopRow,
	TitleBlock,
	PageTitle,
	ActionsRow,
	SecondaryAction,
	PrimaryAction,
	SummaryCard,
	SummaryItem,
	SummaryLabel,
	SummaryValue,
	StatusPill,
	SectionTitle,
	TableCard,
	TotalsCard,
	TotalItem,
	TotalLabel,
	TotalValue,
	FooterActions,
	BackButton,
	InfoIva,
	TerciaryAction,
} from "./styles";
import {
	openNotificationWithIcon,
	TYPE,
} from "../../../../../utils/notificationToast";
import Main from "../../../../layout/main/Main";
import LoadingSkeleton from "./components/loading-skeleton/LoadingSkeleton";
import {
	get_order_by_id_with_status,
	update_order_state,
} from "../../../../../api/endpoints/orders";
import OrderTable from "./components/order-table/OrderTable";
import { numberWithDotAndCommas } from "../../../../../utils/numberWithDotAndComas";
import moment from "moment";
import { CONSTANTS } from "../../../../../utils/constants";
import {
	InfoCircleOutlined,
	PlusOutlined,
	RetweetOutlined,
} from "@ant-design/icons";
import { TerciaryButton } from "../../../buyer/my-buys/buys/styles";
import { COLORS } from "../../../../layout/theme";

const { confirm } = Modal;

export default function MarketOrderDetail() {
	const { id } = useParams();
	const [form] = Form.useForm();
	const navigate = useNavigate();

	const [submitting, setSubmitting] = useState(false);
	const [initialValues, setInitialValues] = useState(null);
	const [loading, setLoading] = useState(false);
	const [orderStateChange, setOrderStateChange] = useState(false);

	useEffect(() => {
		setLoading(true);

		const fetch_order_by_id = async () => {
			const data = await get_order_by_id_with_status(id);

			const order = {
				id: data.order.id,
				created: moment(data.order.created).format("DD/MM/YYYY"),
				client: data.order.clientName,
				photoUrl: data.order.clientPhotoUrl,
				name: data.order.userFirstName + " " + data.order.userLastName,
				email: data.order.userEmail,
				distributorId: data.order.distributorId,
				distributorName: data.order.distributorName,
				distributorPhoto: data.order.distributorPhotoUrl,
				pointOfSaleId: data.order.pointOfSaleId,
				pointOfSaleName: data.order.pointOfSaleName,
				pointOfSaleAddress: data.order.pointOfSaleAddress,
				quantityItems: data.order.quantityItems,
				subTotal: data.order.subtotal,
				total: data.order.total,
				orderNumber: data.order.orderNumber,
				orderNumId: data.order.orderNumId,
				orderState: data.order.orderState,
				orderSubState: data.order.orderSubState,
				pointOfSaleProvince: data.order.pointOfSaleProvince,
				pointOfSaleLocality: data.order.pointOfSaleLocality,
				items: data.items.map((p) => ({
					key: p.id,
					id: p.id,
					orderId: p.orderId,
					orderNumber: p.orderNumber,
					productBrand: p.productBrand,
					productClient: p.productClient,
					productDeleted: p.productDeleted,
					productDiscount: p.productDiscount,
					productDraft: p.productDraft,
					productEan13: p.productEan13,
					productGeneralDiscount: p.productGeneralDiscount,
					productId: p.productId,
					productOfferPrice: p.productOfferPrice,
					productPaused: p.productPaused,
					productPhotoUrl: p.productPhotoUrl,
					productPrice: p.productPrice,
					productQuantity: p.productQuantity,
					productStateInOrder: p.productStateInOrder,
					productStateInOrderDate: p.productStateInOrderDate,
					productTitle: p.productTitle,
					productTriggerDiscount: p.productTriggerDiscount,
					productTriggerQty: p.productTriggerQty,
					productUnitsBilled: p.productUnitsBilled,
					productUnitsPending: p.productUnitsPending,
					productUnitsTRF: p.productUnitsTRF,
					productComboId: p.productComboId,
					productComboName: p.productComboName,
				})),
			};

			setInitialValues(order);
			setLoading(false);
		};

		if (id) {
			fetch_order_by_id();
		}
	}, [id, orderStateChange]);

	const onFinish = async () => {
		try {
			setSubmitting(true);
			navigate("/admin/marketOrders");
		} catch (error) {
			console.log(error);
			openNotificationWithIcon(TYPE.ERROR, "Error");
		} finally {
			setSubmitting(false);
		}
	};

	const selectStateToShow = (state) => {
		switch (state) {
			case CONSTANTS.ORDER_STATE_PENDING:
				return "Pendiente";
			case CONSTANTS.ORDER_STATE_ACTIVE:
				return "Activa";
			case CONSTANTS.ORDER_STATE_SENDED:
				return "Enviada a Droguería";
			case CONSTANTS.ORDER_STATE_CANCELED:
				return "Cancelada";
			case CONSTANTS.ORDER_STATE_PROCESSED:
				return "Procesada por droguería";
			default:
				return state;
		}
	};

	const getStatusColors = (state) => {
		switch (state) {
			case CONSTANTS.ORDER_STATE_ACTIVE:
				return { bg: COLORS.LightSecondary, color: COLORS.Secondary };
			case CONSTANTS.ORDER_STATE_PENDING:
				return { bg: COLORS.LightWarning, color: COLORS.Warning };
			case CONSTANTS.ORDER_STATE_SENDED:
				return { bg: COLORS.LightSuccess, color: COLORS.Success };
			case CONSTANTS.ORDER_STATE_PROCESSED:
				return { bg: COLORS.LightDefault, color: COLORS.Default };
			case CONSTANTS.ORDER_STATE_CANCELED:
				return { bg: COLORS.LightDanger, color: COLORS.Danger };
			default:
				return { bg: COLORS.LightDefault, color: COLORS.Default };
		}
	};

	const handleActiveOrder = () => {
		confirm({
			title: "¿Seguro que quiere activar esta orden?",
			icon: <InfoCircleOutlined style={{ color: "blue" }} />,
			content: "El pedido será activado",
			okText: "Sí",
			okType: "default",
			cancelText: "No",
			onOk: () => {
				activeOrderAction();
			},
		});
	};

	const handlePauseOrder = () => {
		confirm({
			title: "¿Seguro que quiere pausar esta orden?",
			icon: <InfoCircleOutlined style={{ color: "blue" }} />,
			content: "El pedido será pausado",
			okText: "Sí",
			okType: "default",
			cancelText: "No",
			onOk: () => {
				pauseOrderAction();
			},
		});
	};

	const handleCancelOrder = () => {
		confirm({
			title: "¿Seguro que quiere cancelar esta orden?",
			icon: <InfoCircleOutlined style={{ color: "blue" }} />,
			content: "El pedido será anulado",
			okText: "Sí",
			okType: "default",
			cancelText: "No",
			onOk: () => {
				cancelOrderAction();
			},
		});
	};

	const cancelOrderAction = async () => {
		const _state = {
			id: initialValues.id,
			state: CONSTANTS.ORDER_STATE_CANCELED,
		};
		await update_order_state(initialValues.id, _state);
		setOrderStateChange((prev) => !prev);
	};

	const pauseOrderAction = async () => {
		const _state = {
			id: initialValues.id,
			state: CONSTANTS.ORDER_STATE_PENDING,
		};
		await update_order_state(initialValues.id, _state);
		setOrderStateChange((prev) => !prev);
	};

	const activeOrderAction = async () => {
		const _state = {
			id: initialValues.id,
			state: CONSTANTS.ORDER_STATE_ACTIVE,
		};
		await update_order_state(initialValues.id, _state);
		setOrderStateChange((prev) => !prev);
	};

	if (!id) navigate("/admin/compras");

	const effectiveState =
		initialValues?.orderSubState || initialValues?.orderState;
	const statusColors = getStatusColors(effectiveState);

	return (
		<Main>
			<Main.Header>
				<Main.Breadcrumb>
					<Main.BreadcrumbItem>
						<Link to="/">Home</Link>
					</Main.BreadcrumbItem>
					<Main.BreadcrumbSeparator />
					<Main.BreadcrumbItem>
						<Link to="/admin/marketOrders">Ordenes</Link>
					</Main.BreadcrumbItem>
					<Main.BreadcrumbSeparator />
					<Main.ActiveBreadcrumbItem>
						Orden #{initialValues?.orderNumId || id}
					</Main.ActiveBreadcrumbItem>
				</Main.Breadcrumb>
			</Main.Header>

			<Main.Body>
				{!initialValues ? (
					<LoadingSkeleton />
				) : (
					<Form
						form={form}
						name="basic"
						onFinish={onFinish}
						autoComplete="off"
						requiredMark={false}
						layout="vertical"
					>
						<PageWrapper>
							<TopRow>
								<TitleBlock>
									<PageTitle>Detalle TRF #{initialValues.orderNumId}</PageTitle>
								</TitleBlock>

								{/* <ActionsRow>
									<SecondaryAction icon={<RetweetOutlined />}>
										Reenviar Pedido
									</SecondaryAction>

									<PrimaryAction icon={<PlusOutlined />}>
										Crear Nuevo Pedido
									</PrimaryAction>
								</ActionsRow> */}
							</TopRow>

							<InnerForm>
								<OrderData>
									<SummaryCard>
										<SummaryItem>
											<SummaryLabel>Droguería</SummaryLabel>
											<SummaryValue>
												{initialValues.distributorName}
											</SummaryValue>
										</SummaryItem>

										<SummaryItem>
											<SummaryLabel>Punto de Venta</SummaryLabel>
											<SummaryValue>
												{initialValues.pointOfSaleName}
											</SummaryValue>
										</SummaryItem>

										<SummaryItem>
											<SummaryLabel>Fecha de Creación</SummaryLabel>
											<SummaryValue>{initialValues.created}</SummaryValue>
										</SummaryItem>

										<SummaryItem>
											<SummaryLabel>Estado Actual</SummaryLabel>
											<StatusPill
												bg={statusColors.bg}
												color={statusColors.color}
											>
												{selectStateToShow(effectiveState)}
											</StatusPill>
										</SummaryItem>
									</SummaryCard>

									<SectionTitle>Productos del Pedido</SectionTitle>

									<TableCard>
										<Inner>
											<OrderTable data={initialValues} />

											<TotalsCard>
												<TotalItem>
													<TotalLabel>Subtotal:</TotalLabel>
													<TotalValue>
														$ {numberWithDotAndCommas(initialValues.subTotal)}
													</TotalValue>
												</TotalItem>

												<TotalItem>
													<TotalLabel>Descuento:</TotalLabel>
													<TotalValue color={COLORS.Success}>
														$
														{numberWithDotAndCommas(
															Number(
																Math.round(
																	parseFloat(
																		((initialValues.subTotal -
																			initialValues.total) *
																			100) /
																			100 +
																			"e" +
																			2,
																	),
																) +
																	"e-" +
																	2,
															).toFixed(2),
														)}
													</TotalValue>
												</TotalItem>

												<TotalItem>
													<TotalLabel>Total:</TotalLabel>
													<TotalValue>
														$ {numberWithDotAndCommas(initialValues.total)}
													</TotalValue>
												</TotalItem>
											</TotalsCard>

											{/* <InfoIva>IVA no incluido</InfoIva> */}
										</Inner>
									</TableCard>

									{initialValues.orderState !==
										CONSTANTS.ORDER_STATE_SENDED && (
										<ButtonContainer>
											{(initialValues.orderState ===
												CONSTANTS.ORDER_STATE_PENDING ||
												initialValues.orderState ===
													CONSTANTS.ORDER_STATE_CANCELED) && (
												<PrimaryAction
													type="button"
													onClick={handleActiveOrder}
													loading={submitting || loading}
													style={{ minWidth: 220, height: 56 }}
												>
													Activar pedido
												</PrimaryAction>
											)}

											{(initialValues.orderState ===
												CONSTANTS.ORDER_STATE_ACTIVE ||
												initialValues.orderState ===
													CONSTANTS.ORDER_STATE_CANCELED) && (
												<SecondaryAction
													type="button"
													onClick={handlePauseOrder}
													loading={submitting || loading}
													style={{ minWidth: 220, height: 56 }}
												>
													Pausar pedido
												</SecondaryAction>
											)}

											{(initialValues.orderState ===
												CONSTANTS.ORDER_STATE_ACTIVE ||
												initialValues.orderState ===
													CONSTANTS.ORDER_STATE_PENDING) && (
												<SecondaryAction
													type="button"
													onClick={handleCancelOrder}
													loading={submitting || loading}
													style={{
														minWidth: 220,
														height: 56,
														background: "#fee2e2",
														color: "#b91c1c",
													}}
												>
													Cancelar pedido
												</SecondaryAction>
											)}
										</ButtonContainer>
									)}
								</OrderData>

								<FooterActions>
									<BackButton htmlType="submit" loading={submitting}>
										Volver
									</BackButton>
								</FooterActions>
							</InnerForm>
						</PageWrapper>
					</Form>
				)}
			</Main.Body>
		</Main>
	);
}
